import React from 'react';

import { useChildComponent } from '@gogame/hooks-ts';
import { useScreenModalV2, Screen, withScreen } from '@gogame/screens';

import MarketingPlanningHistory from 'scenes/MarketingPlanning/MarketingPlanningGrid/components/MarketingPlanningHistory';
import SummaryByDirectorsDialog from 'scenes/MarketingPlanning/components/SummaryByDirectorsDialog';
import SummaryByManagersDialog from 'scenes/MarketingPlanning/components/SummaryByManagersDialog';
import SummaryByOwnersDialog from 'scenes/MarketingPlanning/components/SummaryByOwnersDialog';

import MarketingPlanningDataTable from './components/MarketingPlanningDataTable';
import { useDiscardMarketingPlan } from './hooks';
import screenReducer from './screenReducer';

const MarketingPlanningGrid = withScreen({
  name: 'marketing-planning',
  reducer: screenReducer,
})(() => {
  const [childComponent, openChildComponent] = useChildComponent();
  const showSummaryByOwnersDialog = useScreenModalV2(SummaryByOwnersDialog);
  const showSummaryByManagersDialog = useScreenModalV2(SummaryByManagersDialog);
  const showSummaryByDirectorsDialog = useScreenModalV2(
    SummaryByDirectorsDialog
  );

  const discardMarketingPlan = useDiscardMarketingPlan();

  const handleShowSummaryByOwners = ({ year, month }) => {
    showSummaryByOwnersDialog({ year, month });
  };

  const handleSummaryByManagers = ({ year, month }) => {
    showSummaryByManagersDialog({ year, month });
  };

  const handleSummaryByDirectors = ({ year, month }) => {
    showSummaryByDirectorsDialog({ year, month });
  };

  const handleShowHistory = ({ year, month }) => {
    openChildComponent(MarketingPlanningHistory, { year, month });
  };

  const handleDiscard = ({ year, month }) => {
    discardMarketingPlan({ year, month });
  };

  return (
    <React.Fragment>
      <Screen.Toolbar />
      <Screen.Body>
        <MarketingPlanningDataTable
          onShowSummaryByOwners={handleShowSummaryByOwners}
          onShowSummaryByManagers={handleSummaryByManagers}
          onShowSummaryByDirectors={handleSummaryByDirectors}
          onShowHistory={handleShowHistory}
          onDiscard={handleDiscard}
        />
        {childComponent}
      </Screen.Body>
    </React.Fragment>
  );
});

export default MarketingPlanningGrid;
